import { AppBar as BaseAppBar, Toolbar } from '@mui/material';
import { ENVIRONMENT_NAME } from 'config/entrypoint';
import { ReactComponent as Logo } from 'images/kuberaLogo.svg';
import { ReactComponent as Kubera } from 'images/kuberaTypography.svg';
import { LanguageSwitcher } from 'layouts/components/LanguageSwitcher/LanguageSwitcher';
import { LoadingIndicator } from 'layouts/components/LoadingIndicator';
import { useSidebarState } from 'react-admin';

import { StyledBox, StyledToolbarBox } from './AuthLayoutAppBar.styled';

export const AuthLayoutAppBar: React.FC = () => {
  const [open] = useSidebarState();

  return (
    <BaseAppBar
      sx={(theme) => {
        return {
          background:
            ENVIRONMENT_NAME === 'prod' ? theme.palette.header.black : theme.palette.header.green,
          boxShadow: 'none',
        };
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }} variant="dense">
        <StyledToolbarBox open={open}>
          <Logo
            style={{
              width: open ? '50px' : '40px',
              transition: 'width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
            }}
          />
          {open && <Kubera style={{ marginLeft: 8 }} />}
        </StyledToolbarBox>
        <StyledBox>
          <LanguageSwitcher />
        </StyledBox>
      </Toolbar>
      <LoadingIndicator />
    </BaseAppBar>
  );
};
